import React from 'react';
import { translations } from '../translations';

const SurgeryTips = ({ language = 'en' }) => {
  const t = translations[language] || translations.en;

  const surgeryTips = {
    en: [
      "Ensure you have completed all pre-operative fasting requirements",
      "Bring comfortable, loose-fitting clothing for after surgery",
      "Arrange for someone to drive you home after the procedure",
      "Stay calm and positive - you're in good hands",
      "Get a good night's sleep before surgery"
    ],
    de: [
      "Stellen Sie sicher, dass Sie alle präoperativen Fastenanforderungen erfüllt haben",
      "Bringen Sie bequeme, lockere Kleidung für nach der Operation mit",
      "Organisieren Sie jemanden, der Sie nach dem Eingriff nach Hause fährt",
      "Bleiben Sie ruhig und positiv - Sie sind in guten Händen",
      "Schlafen Sie in der Nacht vor der Operation gut"
    ]
  };

  const currentTips = surgeryTips[language] || surgeryTips.en;

  return (
    <div className="surgery-tips-content">
      <div className="surgery-tips-header">
        <h2 className="surgery-tips-title">
          {language === 'de' ? 'Operationsvorbereitung' : 'Surgery Preparation'}
        </h2>
      </div>

        <div className="surgery-tips-intro">
          <p>
            {language === 'de' 
              ? 'Heute ist Ihr Operationstag! Hier sind einige wichtige Tipps, um Sie optimal vorzubereiten.'
              : 'Today is your surgery day! Here are some important tips to prepare you optimally.'
            }
          </p>
        </div>

        <div className="surgery-tips-sections">
          <ul className="tips-list">
            {currentTips.map((tip, index) => (
              <li key={index} className="tip-item">
                <span className="tip-text">{tip}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="surgery-tips-footer">
          <div className="encouragement-message">
            <p>
              {language === 'de' 
                ? 'Sie haben sich hervorragend auf diesen Tag vorbereitet. Ihr medizinisches Team ist bereit, Ihnen die beste Versorgung zu bieten.'
                : 'You have prepared excellently for this day. Your medical team is ready to provide you with the best care.'
              }
            </p>
          </div>
        </div>
      </div>
  );
};

export default SurgeryTips; 